



































































import Vue from 'vue';
import { IProduct } from '../../../common/interfaces/products.interface';
import CookieHelper from '../../../helpers/CookieHelper';
import OldCartHelper from '../../../helpers/OldCartHelper';
import DataLayerHelper from '../../../helpers/DataLayerHelper';
import ProductHelper from '../../../helpers/ProductHelper';
import { EProductSliderType } from '../../../common/enums/index.enum';
import { IStyleObject } from '../../../common/interfaces/index.interface';
import { ISlideProductTexts } from '../../../common/interfaces/translations/component.translations.interface';
import FormatHelper from '../../../helpers/FormatHelper';
import OldFormatHelper from '../../../helpers/OldFormatHelper';

export default Vue.extend({
  name: `SlideProduct`,
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    basePrice(): string {
      return `${OldFormatHelper.getPrice(this.product.basePrice.brutto, this.product.currency)} / ${this.product.basePrice.amount} ${this.product.basePrice.unit}`;
    },
    formattedTitle(): string {
      return FormatHelper.replaceUnicodeChars(this.product.title);
    },
    price(): string {
      let price = 0;
      if(this.isPartner) {
        price = this.product.prices.partner.brutto;
      } else {
        price = this.product.prices.customer.brutto;
      }
      return OldFormatHelper.getPrice(price, this.product.currency);
    },
    priceWithoutDiscount(): string | null {
      let priceWithoutDiscount = null;
      if(this.isPartner) {
        priceWithoutDiscount = this.product.prices.partner.bruttoWithoutDiscount ?? null;
      } else {
        priceWithoutDiscount = this.product.prices.customer.bruttoWithoutDiscount ?? null;
      }
      return priceWithoutDiscount ? OldFormatHelper.getPrice(priceWithoutDiscount, this.product.currency) : null;
    },
    styleObject(): IStyleObject {
      return { backgroundImage: `url(${this.product.image}&h=300)` };
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
    texts: {
      required: true,
      type: Object as () => ISlideProductTexts,
    },
    type: {
      default: EProductSliderType.SQUARE,
      validator: val => Object.values(EProductSliderType).includes(val),
    },
  },
  methods: {
    async addItemToCart(): Promise<void> {
      const { matchcode } = this.product;
      this.loading = true;

      const body = {
        amount: 1,
        cartId: CookieHelper.getLastUsedCartId() ?? undefined,
        matchcode,
      };

      await OldCartHelper.addItemToCart(body);

      const atcProducts = {
        id: this.product.matchcode,
        name: this.product.title,
        price: ProductHelper.getPriceUnformatted(this.isPartner, this.product.prices),
        quantity: 1,
      };
      DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);
      this.loading = false;
    },
  },
});
